import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDisplayValue } from "../../../utils/displayValue";

const ApplicationsTable = ({ applications = [] }) => {

  const navigate = useNavigate();
  // const [applications, setApplications] = useState([]);

  // useEffect(() => {
  //   // Simulated API call (Replace with actual API fetch)
  //   setTimeout(() => {
  //     setApplications([
  //       {
  //         id: "001",
  //         customApplicationId: "AP-001",
  //         applicationDate: "2025-01-01",
  //         country: "UK",
  //         degree: "Computer Science",
  //         studentName: "Uchiha",
  //         phoneNumber: "832738289392",
  //         email: "ejdans@gmail.com",
  //         status: "Pending",
  //       },
  //       {
  //         id: "002",
  //         customApplicationId: "AP-002",
  //         applicationDate: "2025-01-02",
  //         country: "UK",
  //         degree: "Engineering",
  //         studentName: "John Doe",
  //         phoneNumber: "832738289393",
  //         email: "johndoe@gmail.com",
  //         status: "In Process",
  //       },
  //       {
  //         id: "003",
  //         customApplicationId: "AP-003",
  //         applicationDate: "2025-01-03",
  //         country: "UK",
  //         degree: "Mathematics",
  //         studentName: "Alice Johnson",
  //         phoneNumber: "832738289394",
  //         email: "alicej@gmail.com",
  //         status: "Completed",
  //       },
  //     ]);
  //   }, 0);
  // }, []);

  // Helper function to format date as DD-MM-YY
  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "Invalid Date";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  };

  const getStatusStyles = (status) => {
    const baseClasses = "inline-block text-center px-4 py-3 w-24 rounded-full";

    switch (status) {
      case "Pending":
        return `${baseClasses} text-xs bg-blue-200 text-blue-800`;
      case "In Process":
        return `${baseClasses} text-xs bg-yellow-200 text-yellow-800`;
      case "Accepted":
        return `${baseClasses} text-xs bg-green-200 text-green-800`;
      case "Rejected":
        return `${baseClasses} text-xs bg-red-200 text-red-800`;
      default:
        return `${baseClasses} text-xs bg-gray-200 text-gray-800`; // fallback style
    }
  };

  return (
    <div className="flex flex-col space-y-6 w-[73%]">
      <div className="px-3 py-6 bg-white rounded shadow-md">
        <h2 className="text-lg font-bold text-gray-500 mb-4">Student's Applications</h2>

        <table className="w-full border-t border-b border-gray-300">
          {/* Table Header */}
          <thead>
            <tr className="border-b border-gray-300">
              <th className="pr-4 py-2 text-center text-gray-400">Application Id</th>
              <th className="px-4 py-2 text-center text-gray-400">Student Name</th>
              <th className="px-4 py-2 text-center text-gray-400">University</th>
              <th className="px-4 py-2 text-center text-gray-400">City</th>
              <th className="px-4 py-2 text-center text-gray-400">Date of Submission</th>
              {/* <th className="px-4 py-2 text-center text-gray-400">Country</th> */}
              {/* <th className="px-4 py-2 text-center text-gray-400">Major</th> */}
              <th className="px-4 py-2 text-center text-gray-400">Status</th>
            </tr>
          </thead>

          {/* Table Body */}
          {applications.length > 0 ? (
            <tbody>
              {applications.slice(0,5).map((app) => (
                <tr
                  key={app._id}
                  className="border-b border-gray-300 cursor-pointer hover:bg-gray-50"
                  onClick={() => navigate('/consultant/application-form', { state: { id: app._id } })}

                >
                  <td className="pr-4 py-4 text-gray-700 text-sm text-center">
                    {getDisplayValue(app.customApplicationId, "")}
                  </td>
                  <td className="px-4 py-4 text-gray-700 text-sm text-center">{getDisplayValue(app.fullName, "")}</td>
                  <td className="px-4 py-4 text-gray-700 text-sm text-center">
                    {getDisplayValue(app.university)}
                  </td>
                  <td className="px-4 py-4 text-gray-700 text-sm text-center">{getDisplayValue(app.city, "")}</td>
                  <td className="px-4 py-4 text-gray-700 text-sm text-center">
                    {formatDate(app.applicationDate)}
                  </td>
                  {/* <td className="px-4 py-4 text-gray-700 text-sm text-center">{app.country}</td> */}
                  {/* <td className="px-4 py-4 text-gray-700 text-sm text-center">{app.major}</td> */}
                  <td className="px-4 py-4 text-gray-700 text-sm text-center">
                    <span className={getStatusStyles(app.status)}>{getDisplayValue(app.status, "")}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="8" className="px-4 py-4 text-sm text-gray-400 font-thin text-center">
                  No applications found.
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default ApplicationsTable;
